import { parseLocationData, parseNumberOfLogsData } from '../../../utils/deviceUtils';
import { Device, DeviceApiResponse, Project } from '../types/device';

/**
 * Transform API response to frontend Device format
 * 
 */
export const transformDeviceFromApi = (apiDevice: DeviceApiResponse): Device => {
  return {
    id: apiDevice.deviceId || apiDevice.id.toString(), // Use deviceId as id, fallback to id as string
    name: `${apiDevice.projectName}`,
    type: apiDevice.weld_type as any, // Determine type based on weld_type
    status: apiDevice.status as any, // Use status directly
    lastSeen: apiDevice.updatedAt, // Use updatedAt as lastSeen
    connection_status: apiDevice.connection_status as any, // Use connection_status directly
    communication_status: apiDevice.communication_status as any, // Use communication_status directly
    response_time: apiDevice?.response_time as any, // Use response_time directly
    weldMachineConnected: apiDevice?.weldMachineConnected as any, // Use weldMachineConnected directly
    EdgeFWVersion: apiDevice?.EdgeFWVersion as any, // Use EdgeFWVersion directly
    connectedEquipment: apiDevice?.connectedEquipment as any, // Use connectedEquipment directly
    project: apiDevice.projectId ? {
      id: apiDevice.projectId,
      name: apiDevice.projectName,
      projectNumber: apiDevice.projectNumber,
      status: 'active',
      startDate: apiDevice.createdAt
    } : undefined,
    metadata: {
      manufacturer: 'CRC-Evans', // Default manufacturer
      model: apiDevice.weld_type || 'Unknown Model',
      serialNumber: apiDevice.deviceId || apiDevice.id.toString(),
      weldType: apiDevice.weld_type || '',
      weldUID: apiDevice.weld_uid || '',
      installationDate: apiDevice.createdAt, // Use createdAt as installationDate
      firmware: 'v1.0.0', // Default firmware
      ipAddress: apiDevice.ipAddress || apiDevice.ip_address || undefined // Map IP address from API
    },
    deviceData: apiDevice || null,
    location: apiDevice.location ? {
      data: apiDevice.location.data,
      parsed: parseLocationData(apiDevice.location.data) || undefined
    } : undefined,
    erase_logs: apiDevice.erase_logs ? {
      data: apiDevice.erase_logs.data,
      error: apiDevice.erase_logs.error
    } : undefined,
    get_time: apiDevice.get_time ? {
      data: apiDevice.get_time.data,
      error: apiDevice.get_time.error
    } : undefined,
    number_of_logs: apiDevice.number_of_logs ? {
      data: apiDevice.number_of_logs.data,
      error: apiDevice.number_of_logs.error,
      parsed: parseNumberOfLogsData(apiDevice.number_of_logs.data) || undefined
    } : undefined,
    password_protection: apiDevice.password_protection ? {
      data: apiDevice.password_protection.data,
      error: apiDevice.password_protection.error
    } : undefined,
    set_time: apiDevice.set_time ? {
      data: apiDevice.set_time.data,
      error: apiDevice.set_time.error
    } : undefined,
    weld_parameter_logs: apiDevice.weld_parameter_logs ? {
      data: apiDevice.weld_parameter_logs.data,
      error: apiDevice.weld_parameter_logs.error
    } : undefined,
  };
};


export const transformProjectFromApi = (apiProject: any): Project => {
  return {
    id: apiProject.projectId || apiProject.project_id || apiProject.id || null,
    name: apiProject.project_name || apiProject.name || apiProject.projectName,
    projectName: apiProject.project_name || apiProject.name || apiProject.projectName,
    projectNumber: apiProject.project_number || apiProject.projectNumber,
    startDate: apiProject.start_date || apiProject.startDate,
    endDate: apiProject.end_date || apiProject.endDate,

  };
};

/**
 * Test function to verify transformation works correctly
 */
export const testDeviceTransformation = () => {
  const testApiDevice: DeviceApiResponse = {
    id: 8,
    deviceId: "device-6",
    status: "Register",
    createdAt: "2025-07-01T12:40:03.000Z",
    projectNumber: "72461989",
    projectName: "m500welding",
    projectId: 23,
    updatedAt: "2025-07-01T12:40:03.000Z",
    updatedBy: "Admin",
    weld_uid: null,
    weld_type: "M500 Welding",
    connection_status: null,
    set_time: {
      data: "",
      error: undefined
    },
    get_time: {
      data: "",
      error: "welding system not ready"
    },
    erase_logs: {
      data: "",
      error: undefined
    },
    number_of_logs: {
      data: "",
      error: undefined
    },
    password_protection: {
      data: "",
      error: undefined
    },
    location: {
      data: "{\"Station\":\"1\",\"BugType\":\"Counterclockwise\",\"BugNum\":\"1\"}",
      error: undefined
    },
    weld_parameter_logs: {
      data: "",
      error: undefined
    }
  };

  const transformedDevice = transformDeviceFromApi(testApiDevice);

  // Verify key mappings
  console.log('Transformed device:', transformedDevice);
  console.log('Location parsed:', transformedDevice.location?.parsed);
  console.log('Get time error:', transformedDevice.get_time?.error);

  return transformedDevice;
};
